<script setup lang="ts">
import { onMounted, ref, nextTick } from "vue"; // Ensure nextTick is imported

import { useUserStore } from "@/stores/userStore";
import { usePageStore } from "@/stores/pageStore";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const pageStore = usePageStore();
const userStore = useUserStore();

const slug = "travel-inspiration";


onMounted(async () => {
  await pageStore.getAll(slug);
});

</script>

<template>
  <div class="container pb-12">
    <div class="self-start responsive-title-1 max-md:max-w-full pt-24">
      {{ t('travelInspiration.title') }}
    </div>

    <div class="mt-8 mb-20 responsive-body-large text-black mix-blend-multiply max-md:max-w-full">
      {{ t('travelInspiration.body') }}
    </div>

    <!-- Loader -->
    <div v-if="pageStore.loading" class="flex justify-center items-center min-h-[300px]">
      <div class="w-12 h-12 border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>
    </div>

    <!-- Blog Posts -->
    <div
        v-else
        class="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
    >
      <div
          v-for="page in pageStore.pageList"
          :key="page.id"
          class="flex flex-col gap-4  bg-white rounded-lg transition-transform transform md:hover:scale-[1.01]"
      >
        <!-- Image -->
        <router-link :to="`/page/${slug}/${page.slug}`">
          <img
              :src="page.imageSet['760w']"
              :alt="page.title"
              class="w-full h-[200px] md:h-[240px] object-cover rounded-2xl"
          />
        </router-link>

        <!-- Content -->
        <div class=" flex flex-col h-full">
          <div class="flex flex-col gap-2 flex-1">
            <span class="text-sm text-gray-500">
              {{
                userStore.formatDateWithCustomPatternMapping(
                    page.publishedAt,
                    "MMM DD, YYYY"
                )
              }}
            </span>
            <router-link :to="`/page/${slug}/${page.slug}`" class="text-lg md:text-xl font-semibold line-clamp-2 hover:underline">
              {{ page.title }}
            </router-link>
            <span class="text-sm md:text-base text-gray-700 line-clamp-3">
              {{ page.seoDescription }}
            </span>
          </div>

          <!-- Button -->
          <router-link
              :to="`/page/${slug}/${page.slug}`"
              class="bg-primary-blue w-fit rounded-2xl px-5 py-2 flex shadow-md transition transform hover:scale-105"
          >
            <img
                src="/assets/icons/svg/Arrow_right_white_16x16.svg"
                alt="arrow"
                class="w-4 h-4"
            />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>